import React, { useEffect, useState, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux';

import DataTableList from '../../components/DataTable/DataTableList'
import { formattedDate } from '../../utils/formattedDate';
import { adminTeamListApi } from '../../api/usersApi';
import NoResults from "../../components/Noresults"

import avatar from '../../assets/images/Avatar.png'

const TeamMember = ({ setShowDeleteTeamPopup, setShowAddTeamPopup, teamListMemo, setCurrentPage, totalPage, setIsLoading, isLoading, isLoadingData, setIsLoadingData, currentPage, setSelectedAdmin, fetchData, setIsEdit, setFirstName, setLastName, setEmail, setPassword }) => {

    const [columnWidths, setColumnWidths] = useState([]);

    useEffect(() => {
        if (teamListMemo?.length > 0) {
            calculateColumnWidths().then(() => {
                setTimeout(() => {
                    setIsLoadingData(false);
                }, 1000);
            });
        }
    }, [teamListMemo]);

    const handleEdit = (row) => {
        setIsEdit(true);
        fetchData(row);
        setSelectedAdmin(row);
        setPassword('');
    }
    const LazyImage = ({ src, alt }) => {
        const [isVisible, setIsVisible] = useState(false);
        const imgRef = useRef();

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1 }
            );

            if (imgRef.current) {
                observer.observe(imgRef.current);
            }

            return () => {
                if (imgRef.current) {
                    observer.unobserve(imgRef.current);
                }
            };
        }, []);

        return (
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                loading="lazy"
            />
        );
    };

    const calculateColumnWidths = () => {
        return new Promise((resolve) => {
            const tempWidths = teamListMemo?.reduce((acc, row) => {
                Object?.keys(row)?.forEach((key) => {
                    const dataValue = row[key]?.toString();
                    const title = row[key];

                    let maxContentLength = 0;

                    maxContentLength = Math?.max(dataValue?.length, title?.length);
                    if (!acc[key] || maxContentLength > acc[key]) {
                        acc[key] = maxContentLength;
                    }
                });
                return acc;
            }, {});
            if (tempWidths !== undefined) {
                const widthMap = Object?.keys(tempWidths)?.reduce((acc, key) => {

                    acc[key] = `${tempWidths[key] * 10 + 40}px`;
                    return acc;
                }, {});

                setColumnWidths(widthMap);
            }
            resolve();
        });

    };
    const customStyles = {
        headCells: {
            style: {
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '24px',
                color: '#666666'
            },
        },
    };

    const columns = [
        {
            name: 'Name',
            selector: (row) => row?.name,
            cell: (row) => (
                <div className="settingTeam-content settingTeamTable" onClick={() => { handleEdit(row); }}>
                    <LazyImage
                        src={row?.profileImg || avatar}
                        alt="Admin image"
                    />
                    <div className="settingTeam-brief">
                        <div className="settingTeam-name">
                            {row?.name || 'NO NAME'} {' '}{row?.lastName}
                        </div>
                        <div className="settingTeam-email">
                            {row?.email || 'NO NAME'}
                        </div>
                    </div>
                </div>
            ),
            sortable: true,
            minWidth: columnWidths['email'] && `${parseInt(columnWidths['email']) + 100}px`,
            minWidth: "322px",
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "16px", paddingBottom: "16px" },
        },
        {
            name: 'Date added',
            selector: (row) => formattedDate(row?.createdAt),
            sortable: true,
            width: columnWidths['createdAt'] && `${parseInt(columnWidths['createdAt']) - 100}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "16px", paddingBottom: "16px", fontSize: 14, lineHeight: `20px` },
        },
        {
            name: 'Last active',
            selector: (row) => formattedDate(row?.lastActive || row?.createdAt),
            sortable: true,
            width: columnWidths['createdAt'] && `${parseInt(columnWidths['createdAt']) - 130}px`,
            style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "16px", paddingBottom: "16px", fontSize: 14, lineHeight: `20px` },
        },
        {
            name: 'Actions',
            cell: (row) => {
                return (
                    <>
                        <div className='table-actions'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => {
                                handleEdit(row);
                            }}>
                                <path d="M2.15703 13.583C2.19149 13.2729 2.20872 13.1179 2.25564 12.9729C2.29726 12.8444 2.35607 12.722 2.43048 12.6092C2.51434 12.482 2.62466 12.3717 2.8453 12.151L12.75 2.24632C13.5784 1.41789 14.9216 1.41789 15.75 2.24632C16.5784 3.07475 16.5784 4.41789 15.75 5.24632L5.84529 15.151C5.62466 15.3717 5.51434 15.482 5.38717 15.5658C5.27434 15.6402 5.15197 15.6991 5.02338 15.7407C4.87845 15.7876 4.72339 15.8048 4.41328 15.8393L1.875 16.1213L2.15703 13.583Z" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" onClick={() => {
                                setShowDeleteTeamPopup(true);
                                setSelectedAdmin(row);
                            }}>
                                <path d="M12 4.5V3.9C12 3.05992 12 2.63988 11.8365 2.31901C11.6927 2.03677 11.4632 1.8073 11.181 1.66349C10.8601 1.5 10.4401 1.5 9.6 1.5H8.4C7.55992 1.5 7.13988 1.5 6.81901 1.66349C6.53677 1.8073 6.3073 2.03677 6.16349 2.31901C6 2.63988 6 3.05992 6 3.9V4.5M7.5 8.625V12.375M10.5 8.625V12.375M2.25 4.5H15.75M14.25 4.5V12.9C14.25 14.1601 14.25 14.7902 14.0048 15.2715C13.789 15.6948 13.4448 16.039 13.0215 16.2548C12.5402 16.5 11.9101 16.5 10.65 16.5H7.35C6.08988 16.5 5.45982 16.5 4.97852 16.2548C4.55516 16.039 4.21095 15.6948 3.99524 15.2715C3.75 14.7902 3.75 14.1601 3.75 12.9V4.5" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </>
                )
            },
            justifyContent: 'flex-end',
            allowOverflow: true,
            button: true,
            minWidth: "55px",
            paddingRight: '16px',
            width: '100px',
            style: { textAlign: 'right', minWidth: '100px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px" },
        },
    ]
    return (
        <div className='team-section'>
            <div className="field-block">
                <div className="team-left-row">
                    <div className="label">Admin users</div>
                    <div className="description">Admins can add and remove team members.</div>
                </div>
                <div className='table-pagination-wrapper setting-team-list'>
                    <div
                        className={`pagesTable dataTable-list ${isLoadingData ? 'loading-list admin-team-load-list' : ''
                            }`}
                    >
                        <DataTableList
                            data={teamListMemo}
                            columns={columns}
                            customStyles={customStyles}
                            onChangePage={setCurrentPage}
                            paginationTotalRows={totalPage}
                            currentPage={currentPage}
                            progressPending={isLoading}
                            progressComponent={
                                <div className="loader-container">
                                    {' '}
                                    <div className="loader"></div>{' '}
                                </div>
                            }
                            noDataComponent={<NoResults title='No team member yet' description="Looks like there aren’t any team member to show right now. Keep an eye out - new member is joining all the time!" />}
                        />
                    </div>
                </div>

            </div>
            <div className="add-team-member-wrapper">
                <div className="add-team-member" onClick={() => {
                    setShowAddTeamPopup(true);
                    setFirstName('');
                    setLastName('');
                    setEmail('');
                    setPassword('');
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.99984 4.16406V15.8307M4.1665 9.9974H15.8332" stroke="#05171A" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Add team member
                </div>
            </div>
            {/* <div className='save-button-group'>
                <div className='cancel-button'>Cancel</div>
                <button className='save-button'>Save</button>
            </div> */}
        </div>
    )
}

export default TeamMember